import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { RankingRoutingModule } from './ranking-routing.module';
import { RankingService } from 'core/services/ranking.service';
import { RankingListComponent } from './ranking-list/ranking-list.component';
import { RankingListRowComponent } from './ranking-list-row/ranking-list-row.component';

@NgModule({
  declarations: [RankingListRowComponent, RankingListComponent],
  imports: [CommonModule, CoreModule, RankingRoutingModule],
  exports: [RankingListComponent],
  providers: [RankingService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RankingModule {}
